<template>
  <AppHeader/>
  <!-- <APPHeaderSticky/> -->
  <main class="app-body">
    <!-- 二级路由 -->
    <RouterView></RouterView>
  </main>
  <AppFooter id="footer"/>
</template>

<script>
import AppHeader from '@/components/app-header.vue'
import AppFooter from '@/components/app-footer.vue'
// import APPHeaderSticky from '@/components/app-header-sticky.vue'
export default {
  name: 'fnhd-layout',
  components: { AppHeader, AppFooter }
}
</script>

<style lang="less" scoped>
.app-body {
  min-height: 600px;
}
</style>
